/* eslint-disable radix */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-param-reassign */
import { Spin } from 'antd';
import IframeResizer from 'iframe-resizer-react';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CONFIG } from '../constants';

const styles = {
  iframe: { border: 'none', width: '1px', minWidth: '100%' }
};
const Pagos360Form = ({ type, config, onSuccess, onError }) => {
  const { PAGOS_URL } = CONFIG;
  const { PAGOS_API_KEY } = CONFIG;
  const [iframeActualizado, setIframeActualizado] = useState(false);
  const [iframe, setIframe] = useState(false);
  const myRef = useRef();

  const onInit = (iframeParam) => {
    if (!iframeActualizado) {
      setIframe(iframeParam);
      // setTimeout(() => setIframeActualizado(true), 500);
    }
  };

  const messageEvent = useCallback(
    (event) => {
      if (PAGOS_URL) {
        if (event.origin !== PAGOS_URL) return;
        if (event.data instanceof Object) {
          if (onError && event.data && event.data.error) {
            onError(event.data);
          } else if (event.data && event.data.info) {
            if (event.data.info.code === 'init') {
              iframe.contentWindow.postMessage(
                {
                  apikey: PAGOS_API_KEY,
                  logo: type !== 'save-card',
                  style: JSON.stringify({
                    'button-border-color': CONFIG.COLOR_PRIMARY,
                    'button-background-color': CONFIG.COLOR_PRIMARY
                  }),
                  ...config
                },
                '*'
              );
            }
            if (event.data.info.code === 'loaded') {
              setIframeActualizado(true);
            }
          } else if (onSuccess) {
            onSuccess(event.data);
          }
        }
      }
    },
    [
      PAGOS_URL,
      onError,
      onSuccess,
      iframe.contentWindow,
      PAGOS_API_KEY,
      type,
      config
    ]
  );

  useEffect(() => {
    window.addEventListener('message', messageEvent);
    return () => {
      window.removeEventListener('message', messageEvent);
    };
  }, [messageEvent]);

  return (
    <>
      <Spin spinning={!iframeActualizado}>
        <IframeResizer
          forwardRef={myRef}
          heightCalculationMethod="taggedElement"
          onInit={onInit}
          warningTimeout={100000}
          id="pago360form"
          src={`${PAGOS_URL}/${type}`}
          title="Pagos360 Form"
          style={styles.iframe}
          // maxHeight={paymentMethodId !== 4 ? 378 : undefined}
          // height="1056px"
          inPageLinks
          checkOrigin={false}
        />
      </Spin>
    </>
  );
};

Pagos360Form.defaultProps = {
  config: {},
  onSuccess: undefined,
  type: ''
};

Pagos360Form.propTypes = {
  config: PropTypes.shape({
    debtId: PropTypes.number,
    clientId: PropTypes.number
  }),
  type: PropTypes.oneOf(['', 'save-card', 'dlocal', 'bancard']),
  onSuccess: PropTypes.func
};

export default Pagos360Form;
